import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Campaign } from '../campaign';


@Component({
  selector: 'campaign-header',
  templateUrl: 'campaign-header.html',
})
export class CampaignHeaderComponent {

  @Input() campaign: Campaign;
  @Input() step: number;
  @Output() saveAndExit = new EventEmitter();

  public saveDisabled: boolean = true;
  public campaignNameError: boolean = false;
  public campaignNameExists: boolean = false;
  public saveAndExitLabel: string;


  constructor() {
    this.saveAndExitLabel = 'campaign.saveButton';
  }

  saveExit($event: Event) {
    this.saveAndExit.emit($event);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/header/campaign-header.component.ts